export default [
  { card: 'visa', type: 'Visa', icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/visa.svg' },
  { card: 'mastercard', type: 'Master Card', icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/master_card.svg' },
  { card: 'amex', type: 'American Express', icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/amex.svg' },
];
